var map = {
	"./BodyContent.vue": [
		"19a8",
		"chunk-13caaaec"
	],
	"./CardsContainer.vue": [
		"6136",
		"chunk-2acf9d96",
		"chunk-cf5f4f96",
		"chunk-4ac2b1ab"
	],
	"./CryptContent.vue": [
		"28fe",
		"chunk-2acf9d96",
		"chunk-cf5f4f96",
		"chunk-4ac2b1ab",
		"chunk-099c1fe4"
	],
	"./CryptTable.vue": [
		"c618",
		"chunk-cf5f4f96"
	],
	"./DataIndicators.vue": [
		"daf8",
		"chunk-fa696058",
		"chunk-9407b2a6",
		"chunk-0d0dd622"
	],
	"./HelpContent.vue": [
		"772c",
		"chunk-0fb2bedb"
	],
	"./MarketContent.vue": [
		"e7db",
		"chunk-9407b2a6",
		"chunk-5fb8a9cf"
	],
	"./OthersCryptContent.vue": [
		"1d45",
		"chunk-2acf9d96",
		"chunk-cf5f4f96",
		"chunk-4ac2b1ab",
		"chunk-08de849e"
	],
	"./OwnedCardContent.vue": [
		"26be",
		"chunk-d9986750"
	],
	"./OwnerBalances.vue": [
		"ebbc",
		"chunk-68a1086f"
	],
	"./ShopContent.vue": [
		"161d",
		"chunk-2acf9d96",
		"chunk-095300fe"
	],
	"./SortDropdown.vue": [
		"17f5",
		"chunk-2acf9d96"
	],
	"./TokenContent.vue": [
		"929b",
		"chunk-67c6b21c"
	],
	"./TransactionModal.vue": [
		"203d"
	],
	"./UniverseBalances.vue": [
		"846b",
		"chunk-18ead82c"
	],
	"./charts/DoughnutChart.vue": [
		"ac274",
		"chunk-fa696058",
		"chunk-770528f7"
	],
	"./charts/LineChart.vue": [
		"33e7",
		"chunk-fa696058",
		"chunk-2d0b9bc8"
	],
	"./layout/AppFooter.vue": [
		"ec0b"
	],
	"./layout/AppHeader.vue": [
		"3f6f"
	],
	"./layout/CzxpRewardEffect.vue": [
		"36a5"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "0f13";
module.exports = webpackAsyncContext;